export const ASSOCIATE_SERVICES = "/api/partnerships/:param/service-details"
export const ASSOCIATE_SERVICE = "/api/partnerships/:param/service-details/:associateServiceParam"

export const SUSPENDED_ASSOCIATE_SERVICE = "/api/partnerships/:param/service-details/:associateServiceParam/suspend"
export const FINISH_ASSOCIATE_SERVICE = "/api/partnerships/:param/service-details/:associateServiceParam/finish"
export const IN_PROGRESS_ASSOCIATE_SERVICE = "/api/partnerships/:param/service-details/:associateServiceParam/in-progress"
export const PERMANENT_ASSOCIATE_SERVICE = "/api/partnerships/:param/service-details/:associateServiceParam/permanent"

export const EXPORT_ASSOCIATE_SERVICE = "/api/service-details/export"
